import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {connect, useDispatch, useSelector} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import {FmlxRadioButton} from 'fmlx-common-ui';

import {showSnackbar} from 'stores/actions/appStateAction';
import {getSelectedTipChannel} from 'stores/selectors/protocolEditorSelectors';
import {addMixingStarterTask} from 'stores/business/taskListMixingBusiness';
import MenuList from './MenuList';
import TaskInfoWrapper from '../Components/TaskInfoWrapper';

import {
  TipChannelType,
  TaskType,
  CardType,
  ProtocolEditorViewMode,
  SerialDilutionStep,
  NormalizationStep,
  PoolingStep,
  TaskDelayUnit,
  NormalizationType,
  ModalSize,
  TrayType,
  Feedback,
} from '../../../constants/dataEnum';

import withIntl from '../../../lib/withIntl';
import {isEmpty} from '../../../lib/objectHelper';

import {
  addGeneralTask,
  addCardGroup,
  editSimpleTransferTipChannel,
  addEjectTipTask,
} from '../../../stores/business/taskListBusinessAction';
import {
  setAllCardIsSelected,
  setAllGroupIsSelected,
  setAllTaskIsSelected,
} from '../../../stores/actions/cardStateAction';

import CustomTips from './CustomTips';
import SerialDilutionMenu from './SerialDilutionMenu';
import BroadcastMenu from './BroadcastMenu';
import PoolingMenu from './PoolingMenu';
import NormalizationMenu from './NormalizationMenu';
import MixingMenu from './MixingMenu';
import PicklistMenu from './PicklistMenu';
import {finalizePicklist} from '../../../stores/business/taskListPicklistBusiness';
import {globalAddUndoItem} from '../../../stores/business/undoRedoBusinessAction';
import {
  setCustomTipCount,
  setPoolingTaskStep,
  setSelectedMenu,
  setSelectedTipChannel,
  setSerialDilutionStep,
  setSimpleTransferEditedType,
} from '../../../stores/actions/protocolEditorAction';
import {
  setCurrentWizardView,
  setNormalizationType as setNormalizationTypeAction,
} from '../../../stores/actions/normalizationStateAction';
import {useStaticCallback} from '../../../lib/customHooks';
import {createSdCardIifNotExist} from '../../../stores/business/taskListSerialDilutionBusiness';
import {hideModal as hideModalAction, showModal as showModalAction} from '../../../stores/actions/modalStateAction';
import ConsolidateTipsMenu from './ConsolidateTipsMenu';
import ConsolidateTipsModalContent from './ConsolidateTipsModalContent';
import {processCreateConsolidateTips} from '../../../stores/business/taskListConsolidateTipsBusiness';
import {getIsConsolidateTipsCardExist} from '../../../stores/selectors/cardStateSelector';
import {ProtocolEditorContext} from '../ContextProviders/ProtocolEditorContext';
import {getLastOpenedProtocol, selectOpenedProtocolIsEjectToCaddy} from '../../../stores/selectors/protocolSelectors';
import {addAirGapTask} from '../TaskList/Task/SimpleTransfer/Tasks/simpleTransferTaskBusiness';

function mapStateToProps(state) {
  const {customTipCount, selectedMenu, simpleTransferEditedType} = state.protocolEditorState;
  return {
    cardStateTasks: state.cardState.tasks,
    cardState: state.cardState.cards,
    protocolCustomTipCount: customTipCount,
    protocolEditorMode: selectedMenu,
    simpleTransferEditedType,
    trayType: state.trayCalibrationState.trayType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    taskListBusinessAddGeneralTask: bindActionCreators(addGeneralTask, dispatch),
    taskListBusinessEditSimpleTransferTipChannel: bindActionCreators(editSimpleTransferTipChannel, dispatch),
    cardStateActionSetAllCardIsSelected: bindActionCreators(setAllCardIsSelected, dispatch),
    cardStateActionSetAllTaskIsSelected: bindActionCreators(setAllTaskIsSelected, dispatch),
    cardStateActionsetAllGroupIsSelected: bindActionCreators(setAllGroupIsSelected, dispatch),
    undoRedoBusinessActionGlobalAddUndoItem: bindActionCreators(globalAddUndoItem, dispatch),
    protocolEditorStateActionSetSelectedTipChannel: bindActionCreators(setSelectedTipChannel, dispatch),
    protocolEditorStateActionSetCustomTipCount: bindActionCreators(setCustomTipCount, dispatch),
    protocolEditorStateActionSetSerialDilutionStep: bindActionCreators(setSerialDilutionStep, dispatch),
    protocolEditorStateActionSetPoolingTaskStep: bindActionCreators(setPoolingTaskStep, dispatch),
    protocolEditorStateActionSetSimpleTransferEditedType: bindActionCreators(setSimpleTransferEditedType, dispatch),
    setNormalizationStep: bindActionCreators(setCurrentWizardView, dispatch),
    setProtocolEditorMode: bindActionCreators(setSelectedMenu, dispatch),
    taskListPicklistBusinessFinalizePicklist: bindActionCreators(finalizePicklist, dispatch),
    taskListBusinessAddCardGroup: bindActionCreators(addCardGroup, dispatch),
    taskListSerialDilutionBusinessCreateSdCardIifNotExist: bindActionCreators(createSdCardIifNotExist, dispatch),
    showModal: bindActionCreators(showModalAction, dispatch),
    hideModal: bindActionCreators(hideModalAction, dispatch),
    setNormalizationType: bindActionCreators(setNormalizationTypeAction, dispatch),
  };
}

function MenuListContainer({
  taskListBusinessAddGeneralTask,
  taskListBusinessEditSimpleTransferTipChannel,
  taskListBusinessAddCardGroup,
  cardStateActionSetAllCardIsSelected,
  cardStateActionSetAllTaskIsSelected,
  cardStateActionsetAllGroupIsSelected,
  cardStateTasks,
  cardState,
  selectedCard,
  intl,
  taskListPicklistBusinessFinalizePicklist,
  taskListSerialDilutionBusinessCreateSdCardIifNotExist,

  undoRedoBusinessActionGlobalAddUndoItem,
  volumeDetailViewChecked,
  protocolEditorStateActionSetSelectedTipChannel,
  protocolCustomTipCount,
  protocolEditorStateActionSetCustomTipCount,
  protocolEditorStateActionSetSerialDilutionStep,
  protocolEditorStateActionSetPoolingTaskStep,
  protocolEditorStateActionSetSimpleTransferEditedType,
  setNormalizationStep,
  protocolEditorMode,
  setProtocolEditorMode,
  setMenuListDivRef,
  simpleTransferEditedType,
  tipChannelRef,
  customTipRef,
  showModal,
  hideModal,
  setNormalizationType,
  trayType,
}) {
  const dispatch = useDispatch();
  const [customTipsOpen, setCustomTipsOpen] = useState(false);
  const [customTipsKey, setCustomTipsKey] = useState(new Date().toString());
  const [delayHovered, setDelayHovered] = useState(false);
  const [confirmationHovered, setConfirmationHovered] = useState(false);
  const [airGapHovered, setAirGapHovered] = useState(false);
  const [wasteHovered, setWasteHovered] = useState(false);
  const [customTipsPosition, setCustomTipsPosition] = useState();
  const [selectedNormalizationIndex, setSelectedNormalizationIndex] = useState(0);
  const insertTaskClickableRef = useRef(null);
  const prevSelectedTipChannel = useRef(null);

  const isConsolidateTipsCardExist = useSelector(getIsConsolidateTipsCardExist);
  const lastOpenedProtocol = useSelector(getLastOpenedProtocol);
  const isEjectToCaddy = useSelector(selectOpenedProtocolIsEjectToCaddy);
  const protocolSelectedTipChannel = useSelector(getSelectedTipChannel);

  const {setMenuListScrollPosition} = useContext(ProtocolEditorContext);

  const taskPickTip = Object.values(cardStateTasks).find(
    (task) => selectedCard?.tasks?.includes(task.ID) && task.type === TaskType.PICK_TIP,
  );
  const taskEjectTip = Object.values(cardStateTasks).find(
    (task) => selectedCard?.tasks?.includes(task.ID) && task.type === TaskType.EJECT_TIP,
  );
  const insertTask = Object.values(cardStateTasks).find(
    (task) => selectedCard?.tasks?.includes(task.ID) && task.type === TaskType.INSERT_TASK,
  );
  const aspirateDispenseTask = Object.values(cardStateTasks).find(
    (task) =>
      selectedCard?.tasks?.includes(task.ID) && (task.type === TaskType.ASPIRATE || task.type === TaskType.DISPENSE),
  );

  const editablePickTipChannel = Boolean(
    simpleTransferEditedType === TaskType.PICK_TIP || (taskPickTip && !aspirateDispenseTask && !taskEjectTip),
  );

  const customTipsRef = useRef(null);

  async function onWasteBinClick() {
    if (protocolSelectedTipChannel) {
      dispatch(addEjectTipTask(isEjectToCaddy ? 1 : 0));
      if (selectedCard.isInsertTask) {
        dispatch(
          showSnackbar(
            Feedback.SUCCESS,
            intl.formatMessage({
              id: 'protocolEditor.taskList.insertTask.notification.success',
            }),
          ),
        );
      }

      await dispatch(setSelectedTipChannel(''));
      await dispatch(setCustomTipCount(null));
      dispatch(globalAddUndoItem());
    }
  }

  async function onSelectPipettingTipChannel(type) {
    await cardStateActionSetAllTaskIsSelected(false);

    if (protocolSelectedTipChannel !== type && !(taskEjectTip && simpleTransferEditedType === TaskType.PICK_TIP)) {
      await protocolEditorStateActionSetSelectedTipChannel(type);
      if (type !== TipChannelType.TIP_CHANNEL_CUSTOM) {
        prevSelectedTipChannel.current = type;
      }
      if (!editablePickTipChannel) {
        await cardStateActionSetAllCardIsSelected(false);
        await cardStateActionsetAllGroupIsSelected(false);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (
        !selectedCard?.isInsertTask &&
        (isEmpty(selectedCard) || selectedCard.type !== CardType.SIMPLE_TRANSFER || taskEjectTip)
      ) {
        await protocolEditorStateActionSetSelectedTipChannel('');
        prevSelectedTipChannel.current = null;
      }
    }
  }

  async function onAddGeneralTask(taskType) {
    let taskData = {type: taskType};
    let cardType;

    switch (taskType) {
      case TaskType.DELAY:
        cardType = CardType.DELAY;
        taskData = {
          delayTime: 0,
          delayUnit: TaskDelayUnit.SECOND,
          delayMessage: '',
          ...taskData,
        };
        break;
      case TaskType.USER_CONFIRMATION_EJECT:
        cardType = CardType.CONFIRMATION;
        taskData = {
          message: '',
          ...taskData,
        };
        break;
      case TaskType.AIR_GAP: {
        dispatch(addAirGapTask(selectedCard));
        return;
      }
      default:
        break;
    }

    if ((taskEjectTip && !selectedCard.isInsertTask) || selectedCard.type !== CardType.SIMPLE_TRANSFER) {
      await taskListBusinessAddGeneralTask(null, cardType, taskData);
    } else {
      await taskListBusinessAddGeneralTask(selectedCard.ID, cardType, taskData);

      if (selectedCard.isInsertTask && taskEjectTip) {
        await protocolEditorStateActionSetSelectedTipChannel(null);
        await protocolEditorStateActionSetCustomTipCount(null);
      }
    }
  }

  function getIsTipChannelIsSelected(tipChannel) {
    return protocolSelectedTipChannel === tipChannel;
  }

  function getIsTipChannelIsDisabled(tipChannel) {
    return !!(
      isConsolidateTipsCardExist ||
      (selectedCard?.tasks?.length &&
        (!taskEjectTip || (taskEjectTip && insertTask) || (simpleTransferEditedType === null && !insertTask)) &&
        protocolSelectedTipChannel &&
        protocolSelectedTipChannel !== tipChannel &&
        !editablePickTipChannel) ||
      (protocolEditorMode !== ProtocolEditorViewMode.SIMPLE_TRANSFER &&
        protocolEditorMode !== ProtocolEditorViewMode.MIXING)
    );
  }

  const onCustomTipsSelectedHandler = async (tips) => {
    if (simpleTransferEditedType === TaskType.PICK_TIP) {
      await protocolEditorStateActionSetSelectedTipChannel('');
      await protocolEditorStateActionSetCustomTipCount(null);
      await protocolEditorStateActionSetSimpleTransferEditedType(null);
      await cardStateActionSetAllTaskIsSelected(false);
    } else {
      await protocolEditorStateActionSetCustomTipCount(tips);
    }
    if (editablePickTipChannel) await taskListBusinessEditSimpleTransferTipChannel(selectedCard.ID, null, tips);
    setCustomTipsOpen(false);
    undoRedoBusinessActionGlobalAddUndoItem();
  };

  const isCustomTipActive = () =>
    selectedCard?.type === CardType.SIMPLE_TRANSFER &&
    selectedCard?.tasks?.length &&
    (!taskEjectTip || (taskEjectTip && insertTask)) &&
    protocolCustomTipCount &&
    !editablePickTipChannel;

  const isSerialDilutionMenuSelected = () => protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION;
  const onSerialDilutionMenuClick = async () => {
    if (!isSerialDilutionMenuSelected()) {
      await cardStateActionSetAllCardIsSelected(false);
      await cardStateActionsetAllGroupIsSelected(false);
    }

    await protocolEditorStateActionSetSelectedTipChannel('');
    await taskListSerialDilutionBusinessCreateSdCardIifNotExist();

    await setProtocolEditorMode(ProtocolEditorViewMode.SERIAL_DILUTION);
    await protocolEditorStateActionSetSerialDilutionStep(SerialDilutionStep.SERIAL_DILUTION_SETTINGS);

    undoRedoBusinessActionGlobalAddUndoItem();
  };

  const serialDilutionMenuDisabled = () => {
    const {sdRawTasks} = selectedCard;
    // const hasAnySdRawTasks = sdRawTasks && Object.keys(sdRawTasks).length > 0 && !sdRawTasks[SerialDilutionStep.SET_SAMPLE_SOURCE]?.skipped && !sdRawTasks[SerialDilutionStep.SET_DILUENT_SOURCE]?.skipped;
    let hasAnySdRawTasks = false;
    if (sdRawTasks) {
      const sdRawTaskIds = Object.keys(sdRawTasks);
      if (sdRawTaskIds.length > 0) {
        hasAnySdRawTasks = !sdRawTasks[SerialDilutionStep.SET_DILUENT_SOURCE]?.skipped;
      }

      if (!hasAnySdRawTasks && sdRawTaskIds.length > 1) {
        hasAnySdRawTasks = !sdRawTasks[SerialDilutionStep.SET_SAMPLE_SOURCE]?.skipped;
      }

      if (sdRawTaskIds.length > 2) {
        hasAnySdRawTasks = true;
      }
    }

    return (
      isConsolidateTipsCardExist ||
      (protocolSelectedTipChannel && !taskEjectTip) ||
      (protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION && hasAnySdRawTasks) ||
      protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
      protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
      protocolEditorMode === ProtocolEditorViewMode.POOLING ||
      protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
      selectedCard.isInsertTask ||
      simpleTransferEditedType === TaskType.PICK_TIP
    );
  };

  const addNormalizationMenuSelected = () => protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION;
  const addNormalizationMenuDisabled = () =>
    isConsolidateTipsCardExist ||
    (protocolSelectedTipChannel && !taskEjectTip) ||
    protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
    protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
    protocolEditorMode === ProtocolEditorViewMode.POOLING ||
    protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
    selectedCard.isInsertTask ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const addNormalizationMenuChange = async () => {
    let typeOfNormalization = NormalizationType.FIXED_SAMPLE_VOLUME;
    const modalContent = (
      <>
        <p className="normalization-type-modal-text">{intl.formatMessage({id: 'modal.normalizationType.text'})}</p>
        <FmlxRadioButton
          items={[
            {
              content: intl.formatMessage({
                id: 'modal.normalizationType.text.fixedSampleVolume',
              }),
              hint: intl.formatMessage({
                id: 'modal.normalizationType.text.fixedSampleVolume.hint',
              }),
              type: 'information',
            },
            {
              content: intl.formatMessage({
                id: 'modal.normalizationType.text.fixedDiluentVolume',
              }),
              hint: intl.formatMessage({
                id: 'modal.normalizationType.text.fixedDiluentVolume.hint',
              }),
              type: 'information',
            },
          ]}
          selectedIndex={selectedNormalizationIndex}
          onChange={({index}) => {
            typeOfNormalization =
              index === 0 ? NormalizationType.FIXED_SAMPLE_VOLUME : NormalizationType.FIXED_DILUENT_VOLUME;
            setSelectedNormalizationIndex(index);
          }}
        />
      </>
    );
    showModal(
      intl.formatMessage({id: 'modal.normalizationType.title'}),
      modalContent,
      [
        {
          style: 'secondary',
          handlerClick: async () => {
            hideModal();
          },
          text: intl.formatMessage({id: 'modal.normalizationType.button.cancel'}),
        },
        {
          style: 'primary',
          handlerClick: async () => {
            await cardStateActionSetAllCardIsSelected(false);
            await cardStateActionsetAllGroupIsSelected(false);
            await setProtocolEditorMode(ProtocolEditorViewMode.NORMALIZATION);
            await setNormalizationStep(NormalizationStep.SET_SAMPLE_LABWARE);
            await setNormalizationType(typeOfNormalization);
            undoRedoBusinessActionGlobalAddUndoItem();
            hideModal();
          },
          text: intl.formatMessage({id: 'modal.normalizationType.button.confirm'}),
        },
      ],
      () => {
        hideModal();
      },
    );
  };

  const addBroadcastMenuSelected = () => protocolEditorMode === ProtocolEditorViewMode.BROADCAST;
  const addBroadcastMenuDisabled = () =>
    isConsolidateTipsCardExist ||
    (protocolSelectedTipChannel && !taskEjectTip) ||
    protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
    protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
    protocolEditorMode === ProtocolEditorViewMode.POOLING ||
    protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
    selectedCard.isInsertTask ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const addBroadcastClick = async () => {
    await cardStateActionSetAllCardIsSelected(false);
    await cardStateActionsetAllGroupIsSelected(false);
    await setProtocolEditorMode(ProtocolEditorViewMode.BROADCAST);
    undoRedoBusinessActionGlobalAddUndoItem();
  };

  const addPoolingMenuSelected = () => protocolEditorMode === ProtocolEditorViewMode.POOLING;
  const addPoolingMenuDisabled = () =>
    isConsolidateTipsCardExist ||
    (protocolSelectedTipChannel && !taskEjectTip) ||
    protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
    protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
    protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
    protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
    selectedCard.isInsertTask ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const addPoolingClick = async () => {
    await cardStateActionSetAllCardIsSelected(false);
    await cardStateActionsetAllGroupIsSelected(false);
    await setProtocolEditorMode(ProtocolEditorViewMode.POOLING);
    await protocolEditorStateActionSetPoolingTaskStep(PoolingStep.SET_SOURCE);
    undoRedoBusinessActionGlobalAddUndoItem();
  };

  const addMixingMenuSelected = () => protocolEditorMode === ProtocolEditorViewMode.MIXING;

  const addMixingMenuDisabled = () =>
    isConsolidateTipsCardExist ||
    protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
    protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
    protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
    protocolEditorMode === ProtocolEditorViewMode.POOLING ||
    protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const onAddMixing = async () => {
    if (
      protocolEditorMode === ProtocolEditorViewMode.SIMPLE_TRANSFER &&
      (protocolSelectedTipChannel || selectedCard.isInsertTask)
    ) {
      dispatch(
        addGeneralTask(selectedCard.ID, CardType.SIMPLE_TRANSFER, {
          type: TaskType.MIXING,
          volume: 0,
        }),
      );
      dispatch(setSimpleTransferEditedType(TaskType.MIXING));
    } else {
      await cardStateActionSetAllCardIsSelected(false);
      await cardStateActionsetAllGroupIsSelected(false);
      await setProtocolEditorMode(ProtocolEditorViewMode.MIXING);
      dispatch(addMixingStarterTask());
      undoRedoBusinessActionGlobalAddUndoItem();
    }
  };

  const addPicklistMenuDisabled = () =>
    isConsolidateTipsCardExist ||
    (protocolSelectedTipChannel && !taskEjectTip) ||
    protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
    protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
    protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
    protocolEditorMode === ProtocolEditorViewMode.POOLING ||
    protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
    selectedCard.isInsertTask ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const addPicklistClick = () => {
    cardStateActionSetAllCardIsSelected(false);
    cardStateActionsetAllGroupIsSelected(false);
  };

  const handleConfirmCsvImport = async (totalDeckIdNeedToDefine) => {
    if (totalDeckIdNeedToDefine) {
      await setProtocolEditorMode(ProtocolEditorViewMode.PICKLIST);
    } else {
      await setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
      if (totalDeckIdNeedToDefine === 0) {
        await taskListPicklistBusinessFinalizePicklist(false, taskListBusinessAddCardGroup);
      }
    }
    undoRedoBusinessActionGlobalAddUndoItem();
  };

  // TODO: move out from the component
  const getButtonStyle = (disabled, hover, color, hoverColor, fontColor, fontColorHovered) => {
    if (disabled) {
      return {};
    }
    if (hover && !disabled) {
      return {
        border: `1px solid ${hoverColor}`,
        backgroundColor: `${hoverColor}`,
        color: fontColorHovered,
      };
    }
    return {
      border: `1px solid ${color}`,
      backgroundColor: `${color}`,
      color: fontColor,
    };
  };

  const handleScroll = (event) => {
    if (customTipsRef.current) {
      const {bottom} = customTipsRef.current.getBoundingClientRect();
      setCustomTipsPosition(bottom - 43);
    }

    setMenuListScrollPosition(event.currentTarget.scrollTop);
  };

  useEffect(() => {
    if (customTipsRef.current) {
      const {bottom} = customTipsRef.current.getBoundingClientRect();
      setCustomTipsPosition(bottom - 43);
    }
  }, [customTipsRef]);

  useEffect(() => {
    setMenuListDivRef(insertTaskClickableRef);
  });

  const onClickCustomTips = useStaticCallback(async () => {
    if (
      isCustomTipActive() ||
      getIsTipChannelIsDisabled(-1) ||
      (taskPickTip &&
        simpleTransferEditedType === null &&
        protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_CUSTOM)
    ) {
      return;
    }

    if (protocolSelectedTipChannel !== TipChannelType.TIP_CHANNEL_CUSTOM || !protocolCustomTipCount) {
      onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_CUSTOM);
      setCustomTipsOpen(!customTipsOpen);
    } else if (protocolCustomTipCount && customTipsOpen) {
      setCustomTipsOpen(!customTipsOpen);
    } else {
      await onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_CUSTOM);
      await protocolEditorStateActionSetCustomTipCount(null);
      setCustomTipsKey(new Date().toString());
      undoRedoBusinessActionGlobalAddUndoItem();
    }
  });

  const onExpandCustomTips = useStaticCallback(() => {
    if (protocolSelectedTipChannel !== TipChannelType.TIP_CHANNEL_CUSTOM || !protocolCustomTipCount) {
      onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_CUSTOM);
    }
    setCustomTipsOpen(!customTipsOpen);
  });

  const onCloseCustomTips = useStaticCallback(async () => {
    setCustomTipsOpen(false);
    if (protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_CUSTOM && !protocolCustomTipCount) {
      if (prevSelectedTipChannel.current && editablePickTipChannel && customTipsOpen) {
        onSelectPipettingTipChannel(prevSelectedTipChannel.current);
      } else {
        onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_CUSTOM);
      }
    }
  });

  const handleConfirmAddConsolidateTips = () => {
    dispatch(processCreateConsolidateTips());
    hideModal();
  };

  const handleConsolidateTipsMenuClick = () => {
    const modalTitle = intl.formatMessage({id: 'modal.protocolEditor.consolidateTips.title'});
    const cancelButtonText = intl.formatMessage({
      id: 'modal.protocolEditor.consolidateTips.cancelButton',
    });
    const confirmButtonText = intl.formatMessage({
      id: 'modal.protocolEditor.consolidateTips.confirmButton',
    });

    const btnAction = [
      {
        text: cancelButtonText,
        style: 'secondary',
        handlerClick: () => hideModal(),
      },
      {
        text: confirmButtonText,
        style: 'primary',
        handlerClick: handleConfirmAddConsolidateTips,
      },
    ];

    showModal(
      modalTitle,
      <ConsolidateTipsModalContent />,
      btnAction,
      () => {
        hideModal();
      },
      'consolidate-tips-modal',
      true,
      ModalSize.EXTRA_LARGE,
    );
  };

  const getWastebinTask = () =>
    !taskEjectTip ||
    taskEjectTip.labwareID ||
    selectedCard?.type === CardType.SERIAL_DILUTION ||
    selectedCard?.type === CardType.BROADCAST ||
    selectedCard?.type === CardType.POOLING
      ? []
      : [taskEjectTip];

  const {disabled: isConsolidateTipsDisabled, tooltipMessage: consolidateTipsTooltipMessage} = (() => {
    let disabled = false;
    let tooltipMessage = '';

    if (trayType !== TrayType.DOUBLE_CADDY || lastOpenedProtocol.trayType !== TrayType.DOUBLE_CADDY) {
      disabled = true;
      tooltipMessage = intl.formatMessage({
        id: 'protocolEditor.menuList.addConsolidateTips.tooltip.noDualCaddy',
      });
    } else if (isConsolidateTipsCardExist) {
      disabled = true;
      tooltipMessage = intl.formatMessage({
        id: 'protocolEditor.menuList.addConsolidateTips.tooltip.consolidateTipsExist',
      });
    } else if (!_.isEmpty(cardState)) {
      disabled = true;
      tooltipMessage = intl.formatMessage({
        id: 'protocolEditor.menuList.addConsolidateTips.tooltip.transferExist',
      });
    } else if (protocolSelectedTipChannel && !taskEjectTip) {
      disabled = true;
    } else if (protocolEditorMode !== ProtocolEditorViewMode.SIMPLE_TRANSFER) {
      disabled = true;
    }

    return {
      disabled,
      tooltipMessage,
    };
  })();

  const isDelayMenuDisabled =
    isConsolidateTipsCardExist ||
    protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
    protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
    protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
    protocolEditorMode === ProtocolEditorViewMode.POOLING ||
    protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const isConfirmationMenuDisabled =
    isConsolidateTipsCardExist ||
    protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
    protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
    protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
    protocolEditorMode === ProtocolEditorViewMode.POOLING ||
    protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const isAirGapMenuDisabled =
    isConsolidateTipsCardExist ||
    protocolEditorMode !== ProtocolEditorViewMode.SIMPLE_TRANSFER ||
    !(protocolSelectedTipChannel && taskPickTip) ||
    simpleTransferEditedType === TaskType.PICK_TIP;

  const getGeneralTooltipMessage = () => {
    if (isConsolidateTipsCardExist) {
      return intl.formatMessage({
        id: 'protocolEditor.menuList.general.tooltip.consolidateTipsExist',
      });
    }
    return '';
  };

  const getPickListTooltipMessage = () => {
    if (isConsolidateTipsCardExist) {
      return intl.formatMessage({
        id: 'protocolEditor.menuList.general.tooltip.consolidateTipsExist',
      });
    }

    const isPickListMenuDisabled = addPicklistMenuDisabled();
    if (isPickListMenuDisabled) {
      return intl.formatMessage({id: 'protocolEditor.picklist.tooltip.enablePicklist'});
    }

    return intl.formatMessage({id: 'protocolEditor.menuList.addCSVImport.tooltip.regular'});
  };

  return (
    <MenuList>
      <div className="menu-list-content-wrapper block-scrollable" style={{width: '145px'}} onScroll={handleScroll}>
        <MenuList.Text
          text={intl.formatMessage({id: 'protocolEditor.pipettingChannelMenu.header1'})}
          disabled={
            !!protocolSelectedTipChannel ||
            (protocolEditorMode !== ProtocolEditorViewMode.SIMPLE_TRANSFER &&
              protocolEditorMode !== ProtocolEditorViewMode.MIXING)
          }
        />
        <div ref={tipChannelRef} className="tip-channel-container" style={{marginBottom: '6px'}}>
          <MenuList.Item
            name={intl.formatMessage({id: 'protocolEditor.pipettingChannelMenu.96tips'})}
            imgPath={`./svg/protocol-editor/tips-channel-96${
              // eslint-disable-next-line no-nested-ternary
              getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_96)
                ? '-selected'
                : getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_96)
                  ? '-disabled'
                  : ''
            }.svg`}
            isSelected={getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_96)}
            disabled={getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_96)}
            tooltipMessage={getGeneralTooltipMessage()}
            onClick={async () => {
              await onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_96);
              await protocolEditorStateActionSetCustomTipCount(null);
              if (editablePickTipChannel) {
                await protocolEditorStateActionSetSimpleTransferEditedType(null);
                await taskListBusinessEditSimpleTransferTipChannel(selectedCard.ID, TipChannelType.TIP_CHANNEL_96);
              }
              setCustomTipsKey(new Date().toString());
              undoRedoBusinessActionGlobalAddUndoItem();
            }}
          />
          <MenuList.Item
            name={intl.formatMessage({id: 'protocolEditor.pipettingChannelMenu.12tips'})}
            imgPath={`./svg/protocol-editor/tips-channel-12${
              // eslint-disable-next-line no-nested-ternary
              getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_12)
                ? '-selected'
                : getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_12)
                  ? '-disabled'
                  : ''
            }.svg`}
            isSelected={getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_12)}
            disabled={getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_12)}
            tooltipMessage={getGeneralTooltipMessage()}
            onClick={async () => {
              await onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_12);
              await protocolEditorStateActionSetCustomTipCount(null);
              if (editablePickTipChannel) {
                await protocolEditorStateActionSetSimpleTransferEditedType(null);
                await taskListBusinessEditSimpleTransferTipChannel(selectedCard.ID, TipChannelType.TIP_CHANNEL_12);
              }
              setCustomTipsKey(new Date().toString());
              undoRedoBusinessActionGlobalAddUndoItem();
            }}
          />
          <MenuList.Item
            name={intl.formatMessage({id: 'protocolEditor.pipettingChannelMenu.8tips'})}
            imgPath={`./svg/protocol-editor/tips-channel-8${
              // eslint-disable-next-line no-nested-ternary
              getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_8)
                ? '-selected'
                : getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_8)
                  ? '-disabled'
                  : ''
            }.svg`}
            isSelected={getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_8)}
            disabled={getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_8)}
            tooltipMessage={getGeneralTooltipMessage()}
            onClick={async () => {
              await onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_8);
              await protocolEditorStateActionSetCustomTipCount(null);
              if (editablePickTipChannel) {
                await protocolEditorStateActionSetSimpleTransferEditedType(null);
                await taskListBusinessEditSimpleTransferTipChannel(selectedCard.ID, TipChannelType.TIP_CHANNEL_8);
              }
              setCustomTipsKey(new Date().toString());
              undoRedoBusinessActionGlobalAddUndoItem();
            }}
          />
          <MenuList.Item
            name={intl.formatMessage({id: 'protocolEditor.pipettingChannelMenu.1tip'})}
            imgPath={`./svg/protocol-editor/tip-channel-1${
              // eslint-disable-next-line no-nested-ternary
              getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_1)
                ? '-selected'
                : getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_1)
                  ? '-disabled'
                  : ''
            }.svg`}
            isSelected={getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_1)}
            disabled={getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_1)}
            tooltipMessage={getGeneralTooltipMessage()}
            onClick={async () => {
              await onSelectPipettingTipChannel(TipChannelType.TIP_CHANNEL_1);
              await protocolEditorStateActionSetCustomTipCount(null);
              if (editablePickTipChannel) {
                await protocolEditorStateActionSetSimpleTransferEditedType(null);
                await taskListBusinessEditSimpleTransferTipChannel(selectedCard.ID, TipChannelType.TIP_CHANNEL_1);
              }
              setCustomTipsKey(new Date().toString());
              undoRedoBusinessActionGlobalAddUndoItem();
            }}
          />
          <MenuList.Item
            menuRef={customTipsRef}
            name={
              !protocolCustomTipCount
                ? intl.formatMessage({id: 'protocolEditor.pipettingChannelMenu.customTips'})
                : `${protocolCustomTipCount?.row}x${protocolCustomTipCount?.column} 
              ${protocolCustomTipCount?.row === 1 && protocolCustomTipCount?.column === 1 ? 'tip' : 'tips'}`
            }
            isSelected={getIsTipChannelIsSelected(TipChannelType.TIP_CHANNEL_CUSTOM)}
            disabled={getIsTipChannelIsDisabled(TipChannelType.TIP_CHANNEL_CUSTOM)}
            tooltipMessage={getGeneralTooltipMessage()}
            onClick={onClickCustomTips}
            onExpand={onExpandCustomTips}
            expandable={!isCustomTipActive()}
          />
        </div>
        <ConsolidateTipsMenu
          onClick={handleConsolidateTipsMenuClick}
          disabled={isConsolidateTipsDisabled}
          tooltipMessage={consolidateTipsTooltipMessage}
        />
        <MenuList.Text
          text={intl.formatMessage({id: 'protocolEditor.pipettingChannelMenu.tipsWasteBin'})}
          disabled={!protocolSelectedTipChannel}
          style={{marginTop: '10px'}}
        />
        <MenuList.Item
          name={intl.formatMessage({
            id: isEjectToCaddy ? 'protocolEditor.menuList.wasteBin.caddy' : 'protocolEditor.menuList.wasteBin',
          })}
          imgPath={`./svg/protocol-editor/tips-waste-bin${
            !(protocolSelectedTipChannel && !taskEjectTip && taskPickTip && simpleTransferEditedType === null)
              ? '-disabled'
              : ''
          }.svg`}
          disabled={!(protocolSelectedTipChannel && !taskEjectTip && taskPickTip && simpleTransferEditedType === null)}
          onClick={onWasteBinClick}
          style={getButtonStyle(
            !(protocolSelectedTipChannel && !taskEjectTip && taskPickTip && simpleTransferEditedType === null),
            wasteHovered,
            '#f2994a',
            '#CC6900',
          )}
          onMouseEnter={() => {
            setWasteHovered(true);
          }}
          onMouseLeave={() => {
            setWasteHovered(false);
          }}
        />
        <MenuList.Gap />
        <PicklistMenu
          disabled={addPicklistMenuDisabled()}
          onClick={addPicklistClick}
          onConfirmCsvImport={handleConfirmCsvImport}
          tooltipMessage={getPickListTooltipMessage()}
        />
        <SerialDilutionMenu
          selected={isSerialDilutionMenuSelected()}
          disabled={serialDilutionMenuDisabled()}
          onClick={onSerialDilutionMenuClick}
          tooltipMessage={getGeneralTooltipMessage()}
        />
        <NormalizationMenu
          selected={addNormalizationMenuSelected()}
          disabled={addNormalizationMenuDisabled()}
          onClick={addNormalizationMenuChange}
          tooltipMessage={getGeneralTooltipMessage()}
        />
        <BroadcastMenu
          selected={addBroadcastMenuSelected()}
          disabled={addBroadcastMenuDisabled()}
          onClick={addBroadcastClick}
          tooltipMessage={getGeneralTooltipMessage()}
        />
        <PoolingMenu
          selected={addPoolingMenuSelected()}
          disabled={addPoolingMenuDisabled()}
          onClick={addPoolingClick}
          tooltipMessage={getGeneralTooltipMessage()}
        />
        <MenuList.Gap />
        <div ref={insertTaskClickableRef}>
          <MixingMenu
            selected={addMixingMenuSelected()}
            disabled={addMixingMenuDisabled()}
            onClick={onAddMixing}
            tooltipMessage={getGeneralTooltipMessage()}
          />
          <MenuList.Item
            name={intl.formatMessage({id: 'protocolEditor.menuList.addDelay'})}
            imgPath={`./svg/protocol-editor/delay${isDelayMenuDisabled ? '-disabled' : ''}.svg`}
            onClick={() => onAddGeneralTask(TaskType.DELAY)}
            style={getButtonStyle(isDelayMenuDisabled, delayHovered, '#2D9CDB', '#006AF5', 'white')}
            disabled={isDelayMenuDisabled}
            onMouseEnter={() => {
              setDelayHovered(true);
            }}
            onMouseLeave={() => {
              setDelayHovered(false);
            }}
            tooltipMessage={getGeneralTooltipMessage()}
          />
          <MenuList.Item
            name={intl.formatMessage({id: 'protocolEditor.menuList.addConfirmation'})}
            imgPath={`./svg/protocol-editor/confirmation${isConfirmationMenuDisabled ? '-disabled' : ''}.svg`}
            onClick={() => onAddGeneralTask(TaskType.USER_CONFIRMATION_EJECT)}
            style={getButtonStyle(isConfirmationMenuDisabled, confirmationHovered, '#2D9CDB', '#006AF5', 'white')}
            disabled={isConfirmationMenuDisabled}
            onMouseEnter={() => {
              setConfirmationHovered(true);
            }}
            onMouseLeave={() => {
              setConfirmationHovered(false);
            }}
            tooltipMessage={getGeneralTooltipMessage()}
          />
          <MenuList.Item
            name={intl.formatMessage({id: 'protocolEditor.menuList.addAirGap'})}
            imgPath={`./svg/protocol-editor/add-airgap${isAirGapMenuDisabled ? '-disabled' : ''}.svg`}
            onClick={() => onAddGeneralTask(TaskType.AIR_GAP)}
            style={getButtonStyle(isAirGapMenuDisabled, airGapHovered, '#2D9CDB', '#006AF5', 'white')}
            disabled={isAirGapMenuDisabled}
            onMouseEnter={() => {
              setAirGapHovered(true);
            }}
            onMouseLeave={() => {
              setAirGapHovered(false);
            }}
            tooltipMessage={getGeneralTooltipMessage()}
          />
        </div>
      </div>
      <div style={{position: 'absolute', left: 13, top: (customTipsPosition ?? 0) + 35}}>
        <TaskInfoWrapper
          // eslint-disable-next-line no-unsafe-optional-chaining
          key={getWastebinTask()[0]?.rowTipCount * getWastebinTask()[0]?.columnTipCount}
          tasks={getWastebinTask()}
          showTaskVolume={selectedCard?.type === CardType.NORMALIZATION ? false : volumeDetailViewChecked}
          fitContent
          showTaskNumber={selectedCard?.type !== CardType.NORMALIZATION}
        />
      </div>
      <CustomTips
        key={customTipsKey}
        initialTipCount={protocolCustomTipCount}
        open={customTipsOpen}
        onTipsSelected={onCustomTipsSelectedHandler}
        onClosed={onCloseCustomTips}
        excludedComponentRef={[customTipsRef]}
        top={customTipsPosition}
        customTipRef={customTipRef}
      />
    </MenuList>
  );
}

MenuListContainer.propTypes = {
  intl: PropTypes.any.isRequired,
  cardStateTasks: PropTypes.object.isRequired,
  cardState: PropTypes.object.isRequired,
  taskListBusinessAddGeneralTask: PropTypes.func.isRequired,
  taskListBusinessEditSimpleTransferTipChannel: PropTypes.func.isRequired,
  cardStateActionSetAllCardIsSelected: PropTypes.func.isRequired,
  cardStateActionSetAllTaskIsSelected: PropTypes.func.isRequired,
  cardStateActionsetAllGroupIsSelected: PropTypes.func.isRequired,
  selectedCard: PropTypes.object,
  undoRedoBusinessActionGlobalAddUndoItem: PropTypes.func.isRequired,

  volumeDetailViewChecked: PropTypes.bool.isRequired,
  protocolEditorStateActionSetSelectedTipChannel: PropTypes.func.isRequired,
  protocolEditorMode: PropTypes.string,
  setProtocolEditorMode: PropTypes.func.isRequired,
  setNormalizationStep: PropTypes.func.isRequired,
  protocolCustomTipCount: PropTypes.object,
  protocolEditorStateActionSetCustomTipCount: PropTypes.func.isRequired,
  protocolEditorStateActionSetSerialDilutionStep: PropTypes.func.isRequired,
  protocolEditorStateActionSetPoolingTaskStep: PropTypes.func.isRequired,
  protocolEditorStateActionSetSimpleTransferEditedType: PropTypes.func.isRequired,
  taskListPicklistBusinessFinalizePicklist: PropTypes.func.isRequired,
  taskListSerialDilutionBusinessCreateSdCardIifNotExist: PropTypes.func.isRequired,
  taskListBusinessAddCardGroup: PropTypes.func.isRequired,
  setMenuListDivRef: PropTypes.func.isRequired,
  simpleTransferEditedType: PropTypes.any,
  tipChannelRef: PropTypes.any.isRequired,
  customTipRef: PropTypes.any.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  setNormalizationType: PropTypes.func.isRequired,
  trayType: PropTypes.string.isRequired,
};

MenuListContainer.defaultProps = {
  selectedCard: {},
  protocolEditorMode: null,
  protocolCustomTipCount: null,
  simpleTransferEditedType: null,
};

function areEqual(prevProps, nextProps) {
  return (
    _.isEqual(prevProps.cardStateTasks, nextProps.cardStateTasks) &&
    _.isEqual(prevProps.cardState, nextProps.cardState) &&
    _.isEqual(prevProps.selectedCard, nextProps.selectedCard) &&
    _.isEqual(prevProps.setNormalizationStep, nextProps.setNormalizationStep) &&
    prevProps.volumeDetailViewChecked === nextProps.volumeDetailViewChecked &&
    prevProps.protocolEditorMode === nextProps.protocolEditorMode
  );
}

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(withIntl(MenuListContainer)), areEqual);
